import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomKeywords = createSvgIcon(
  <path d="M13.456 10.953a4.41 4.41 0 0 0-1.56-5.594 4.39 4.39 0 0 0-4.788-.026 4.416 4.416 0 0 0-.748 6.841 4.405 4.405 0 0 0 5.017.858l2.261 2.262-1.04 1.04a1.475 1.475 0 0 0 0 2.08 1.475 1.475 0 0 0 2.08 0l1.04-1.04a1.475 1.475 0 0 0 2.08 0 1.475 1.475 0 0 0 0-2.08zm-5.017-.858a1.475 1.475 0 0 1 0-2.08 1.475 1.475 0 0 1 2.08 0 1.475 1.475 0 0 1 0 2.08 1.475 1.475 0 0 1-2.08 0" />,
  'CustomKeywords',
);

export default CustomKeywords;
